import { render, staticRenderFns } from "./bar-echart.vue?vue&type=template&id=2abd0ede&scoped=true&"
import script from "./bar-echart.vue?vue&type=script&lang=js&"
export * from "./bar-echart.vue?vue&type=script&lang=js&"
import style0 from "./bar-echart.vue?vue&type=style&index=0&id=2abd0ede&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd0ede",
  null
  
)

export default component.exports